import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { HardHat } from "lucide-react";

function LoginCardHeader() {
  return (
    <div className="bg-slate-900 text-white px-6 py-5 flex items-center gap-3">
      <HardHat className="w-6 h-6" />
      <div>
        <h1 className="text-lg font-black tracking-tighter">PIANIFICAZIONE CANTIERI</h1>
        <p className="text-xs text-slate-300">Distribuzione personale giornaliera</p>
      </div>
    </div>
  );
}

function useLoginSubmit() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (name, password) => {
    setLoading(true);
    setError("");
    try {
      await login(name, password);
      navigate("/" + window.location.search); // preserva deep-link ?mese=&giorno=
    } catch (err) {
      setError(err.response?.data?.detail || "Errore di accesso");
    } finally {
      setLoading(false);
    }
  };
  return { submit, loading, error };
}

function LoginForm({ name, setName, password, setPassword, loading, error, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="p-6 space-y-4">
      <div>
        <label htmlFor="operator-name" className="text-xs font-semibold uppercase tracking-wide text-slate-600">
          Nome operatore
        </label>
        <Input
          id="operator-name"
          data-testid="login-name-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Es. Tiralongo Matteo"
          className="mt-1 rounded-sm"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          autoFocus
        />
      </div>
      <div>
        <label htmlFor="operator-password" className="text-xs font-semibold uppercase tracking-wide text-slate-600">
          Password
        </label>
        <Input
          id="operator-password"
          data-testid="login-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password assegnata dall'amministratore"
          className="mt-1 rounded-sm"
        />
      </div>
      {error && <p data-testid="login-error" className="text-sm text-red-700">{error}</p>}
      <Button data-testid="login-submit-button" type="submit" disabled={loading}
        className="w-full rounded-sm bg-slate-900 hover:bg-slate-700 text-white">
        {loading ? "Accesso..." : "Entra"}
      </Button>
      <p className="text-[11px] text-slate-500 text-center">
        L'accesso è consentito solo agli operatori autorizzati dall'amministratore.
      </p>
    </form>
  );
}

export default function Login() {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const { submit, loading, error } = useLoginSubmit();

  const onSubmit = (e) => {
    e.preventDefault();
    if (name.trim() && password) submit(name, password);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-3">
      <div className="w-full max-w-sm bg-white border border-slate-300 rounded-sm shadow-sm">
        <LoginCardHeader />
        <LoginForm name={name} setName={setName} password={password} setPassword={setPassword}
          loading={loading} error={error} onSubmit={onSubmit} />
      </div>
    </div>
  );
}
